import { render, staticRenderFns } from "./ChecklistProtocolPerson.vue?vue&type=template&id=a7fc670e&scoped=true&"
import script from "./ChecklistProtocolPerson.vue?vue&type=script&lang=js&"
export * from "./ChecklistProtocolPerson.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistProtocolPerson.vue?vue&type=style&index=0&id=a7fc670e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fc670e",
  null
  
)

export default component.exports